import { Grid, PageBackgroundWrapper, VerticalSpacing, Text } from '@custom-components';
import PropTypes from 'prop-types';
import React from 'react';

import { PageSEO } from '../components/PageSEO';

function ErrorPage({ statusCode, statusMessage }) {
  const errorCodeMessage = statusCode ? `An error ${statusCode} occurred on server.` : 'An error occurred on client.';
  const message = statusMessage || errorCodeMessage;

  return (
    <PageBackgroundWrapper>
      <PageSEO title="Error - LodgeLink" />
      <Grid.Container>
        <Grid.Row align="center">
          <Grid.Col>
            <VerticalSpacing>
              <Text.HeadingHero tagName="h2" color="quaternary" align="center" noMargins>
                {statusCode}
              </Text.HeadingHero>
              <Text.CopyBody tagName="p" align="center">
                {message}
              </Text.CopyBody>
            </VerticalSpacing>
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>
    </PageBackgroundWrapper>
  );
}

ErrorPage.getInitialProps = (ctx) => {
  const { res } = ctx || {};

  const { statusCode = null } = res || {};

  return { statusCode };
};

ErrorPage.propTypes = {
  statusCode: PropTypes.number,
  statusMessage: PropTypes.string,
  err: PropTypes.shape({
    statusCode: PropTypes.number,
    message: PropTypes.string
  })
};

ErrorPage.defaultProps = {
  statusCode: null,
  statusMessage: null,
  err: null
};

export { ErrorPage };
export default ErrorPage;
